import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  listItem: {
    padding: 0,
  },
});
